// utils
const EEC_CATEGORY = 'International Flights';

const createListName = (resultType = 'Default', tripType = 'One Way') => {
    // ---- One Way 👇
    // Default One Way Search Results
    // Promoted One Way Search Results

    // ---- Two Way 👇
    // Default Two Way Search Results
    // Promoted Two Way Search Results
    return `${resultType} ${tripType} Search Results`;
};

const createCarriers = (flights, key) => {
    return flights.map(item => item[key]).join(' - ');
};

export default {
    methods: {
        _$if__clearStorage () {
            // ---- One Way / Two Way 👇
            if (this.$storage.getLocalStorage('intEECProduct')) {
                this.$storage.removeLocalStorage('intEECProduct');
            }
            // ---- Checked Out Products 👇
            if (this.$storage.getLocalStorage('intEECProducts')) {
                this.$storage.removeLocalStorage('intEECProducts');
            }
        },
        _$if__sendImpressions (tripType = 'One Way') {
            // destructure data from international store object
            const {
                origin,
                destination,
                results,
            } = this.$store.state.international;
            let resultType;
            const impressions = [];
            // loop through results
            results.forEach(result => {
                const {
                    uniqueId: id,
                    // leavingFlightGroup,
                    total: price,
                    // eecIndex: position,
                } = result;
                // let brand;
                // if (leavingFlightGroup) {
                //     brand = leavingFlightGroup.airlineName;
                // }
                if (result.bestFlight > 0) {
                    resultType = 'Promoted';
                } else {
                    resultType = 'Default';
                }
                impressions.push({
                    id,
                    name: `${origin}-${destination}`,
                    list: createListName(resultType, tripType),
                    // brand,
                    category: EEC_CATEGORY,
                    // position,
                    price,
                });
            });
            // send impressions to GTM
            this.$eec.impressionViewEC(impressions);
        },
        _$if__sendProductDetailView (selectedProduct, tripType) {
            // destructure data from international store object
            const {
                origin,
                destination,
            } = this.$store.state.international;
            const {
                uniqueId: id,
                leavingFlightGroup,
                total: price,
            } = selectedProduct;
            let brand;
            if (leavingFlightGroup) {
                brand = leavingFlightGroup.airlineName;
            }
            let resultType = 'Default';
            if (selectedProduct.bestFlight > 0) {
                resultType = 'Promoted';
            }
            switch (tripType) {
            case 'oneWay':
                tripType = 'One Way';
                break;
            case 'twoWay':
                tripType = 'Two Way';
                break;
            default:
                tripType = 'One Way';
            }
            const detail = {
                actionField: {
                    list: createListName(resultType, tripType),
                },
                products: [{
                    id,
                    name: `${origin}-${destination}`,
                    brand,
                    category: EEC_CATEGORY,
                    price,
                }],
            };
            this.$eec.productDetailViewEC(detail);
        },
        _$if__addToCart (selectedProduct, tripType) {
            // Try To Send Analytics Event
            try {
                // destructure data from international store object
                const {
                    type,
                    origin,
                    originCityName,
                    originList,
                    destination,
                    destinationCityName,
                    destinationList,
                    returning,
                    selectedPackage,
                } = this.$store.state.international;
                const {
                    uniqueId: id,
                    leavingFlightGroup,
                    total: price,
                    eecIndex: position,
                } = selectedProduct;
                let brand;
                if (leavingFlightGroup) {
                    brand = leavingFlightGroup.airlineName;
                }
                let resultType = 'Default';
                if (selectedProduct.bestFlight > 0) {
                    resultType = 'Promoted';
                }
                switch (tripType) {
                case 'oneWay':
                    tripType = 'One Way';
                    break;
                case 'twoWay':
                    tripType = 'Two Way';
                    break;
                default:
                    tripType = 'One Way';
                }
                const products = [];
                // destructure data from store for sending to GTM
                const { adult, child, infant } = this.$store.state.international;
                // create array for simplifying code
                const passengers = [
                    { adult },
                    { child },
                    { infant },
                ];
                // loop through each type of passenger (adult, child, infant)
                passengers.forEach(passengerType => {
                    // get the current passenger type (Adult, Child, Infant)
                    const type = Object.keys(passengerType)[0];
                    // find the number of passengers for current passenger type
                    const numberOfPassengers = passengerType[type];
                    // only send event if current passenger type has passengers
                    if (numberOfPassengers) {
                        products.push({
                            id,
                            name: `${origin}-${destination}`,
                            brand,
                            category: EEC_CATEGORY,
                            // the replace below capitalizes the first character
                            variant: type.replace(/^./, str => str.toUpperCase()),
                            position,
                            quantity: numberOfPassengers,
                            price,
                        });
                    }
                });
                const list = createListName(resultType, tripType);
                this.$eec.impressionClickEC({
                    click: {
                        actionField: {
                            list,
                        },
                        products: [{
                            id,
                            name: `${origin}-${destination}`,
                            brand,
                            category: EEC_CATEGORY,
                            position,
                            price,
                        }],
                    },
                });
                // save added product to local storage
                this.$storage.setLocalStorage('intEECProduct', {
                    actionField: {
                        list,
                    },
                    products,
                });
                // send addToCart data to GTM
                this.$eec.addProductEC({
                    add: {
                        actionField: {
                            list,
                        },
                        products,
                    },
                });

                // WE: send 'Selected - International Flights' and 'Added To Cart - International Flights' events
                let data = {
                    'App Store': '',
                };
                const {
                    leavingFlightGroup: leavingFlights,
                    returningFlightGroup: returningFlights,
                    prices,
                    isCharter,
                    flightGroups,
                } = selectedPackage;
                if (type !== 'multiCity') {
                    const {
                        cabinTypeName: departingCabinTypeName,
                        flightDetails: departingFlightDetails,
                        departureDateTime,
                    } = leavingFlights;
                    const {
                        cabinTypeName: returningCabinTypeName,
                        flightDetails: returningFlightDetails,
                        departureDateTime: returningDepartureDateTime,
                    } = returningFlights || [];
                    data = {
                        ...data,
                        'Arrival City': `${destinationCityName} (${destination})`,
                        'Class': type === 'oneWay' ? departingCabinTypeName : `${departingCabinTypeName} - ${returningCabinTypeName}`,
                        'Departure City': `${originCityName} (${origin})`,
                        'Departure Date': new Date(departureDateTime),
                        'Is Charter': isCharter,
                        'Marketing Carrier': type === 'oneWay' ? createCarriers(departingFlightDetails, 'marketingCarrierName') : `${createCarriers(departingFlightDetails, 'marketingCarrierName')} / ${createCarriers(returningFlightDetails, 'marketingCarrierName')}`,
                        'Operating Carrier': type === 'oneWay' ? createCarriers(departingFlightDetails, 'operatingCarrier') : `${createCarriers(departingFlightDetails, 'operatingCarrier')} / ${createCarriers(returningFlightDetails, 'operatingCarrier')}`,
                        'Price': prices.reduce((result, item) => result + item.total, 0),
                        'Type': type === 'oneWay' ? 'One Way' : 'Round Trip',
                        'Passenger Count': adult + child + infant,
                        'Adult Count': adult,
                        'Child Count': child,
                        'Infant Count': infant,
                        'Passenger Matrix': [adult, child, infant],
                    };
                    if (returning && type === 'twoWay') {
                        data['Return Date'] = new Date(returningDepartureDateTime);
                    }
                } else {
                    const { departureDateTime } = selectedPackage.flightGroups[0];
                    data = {
                        ...data,
                        'Arrival Cities': destinationList.join(' - '),
                        'Class': flightGroups.map(item => item.cabinTypeName).join(' - '),
                        'Departure Cities': originList.join(' - '),
                        'Departure Date': new Date(departureDateTime),
                        // send the last date in the array 👇
                        'Is Charter': isCharter,
                        'Price': prices.reduce((result, item) => result + item.total, 0),
                        'Type': 'Multi-city',
                        'Passenger Count': adult + child + infant,
                        'Adult Count': adult,
                        'Child Count': child,
                        'Infant Count': infant,
                        'Passenger Matrix': [adult, child, infant],
                    };
                }
                this.$webengage.logWebengageEvent('Selected - International Flights', data);
                this.$webengage.logWebengageEvent('Added To Cart - International Flights', data);
            } catch (error) {
                console.warn('[WEBENGAGE]', error); // eslint-disable-line no-console
            }
        },
        _$if__removeFromCart () {
            try {
                let cartData;
                if (this.$storage.getLocalStorage('intEECProduct')) {
                    cartData = this.$storage.getLocalStorage('intEECProduct');
                }
                // send removeFromCart data to GTM
                this.$eec.removeProductEC({
                    remove: cartData,
                });
            } catch (error) {
                console.error(error); // eslint-disable-line no-console
            }
        },
        _$if__sendCheckoutStep (stepNumber, paymentMethod) {
            try {
                let storedProducts = [];
                let products = [];
                if (this.$storage.getLocalStorage('intEECProduct')) {
                    storedProducts = this.$storage.getLocalStorage('intEECProduct');
                }
                if (storedProducts.products.length > 0) {
                    products = storedProducts.products;
                }
                this.$eec.setCheckoutStepNumber({
                    checkout: {
                        actionField: {
                            step: stepNumber,
                        },
                        products,
                    },
                });
                const {
                    type,
                    adult,
                    child,
                    infant,
                    origin,
                    originCityName,
                    originList,
                    destination,
                    destinationCityName,
                    destinationList,
                    returning,
                    selectedPackage,
                } = this.$store.state.international;
                // WE: send 'Checkout Started - International Flights' and 'Checkout Confirmed - International Flights' events
                let data = {
                    'App Store': '',
                };
                const {
                    leavingFlightGroup: leavingFlights,
                    returningFlightGroup: returningFlights,
                    prices,
                    isCharter,
                    flightGroups,
                } = selectedPackage;

                const { departureDateTime } = leavingFlights;
                const { departureDateTime: returnDepartureDateTime } = returningFlights;

                if (type !== 'multiCity') {
                    const {
                        cabinTypeName: departingCabinTypeName,
                        flightDetails: departingFlightDetails,
                    } = leavingFlights;
                    const {
                        cabinTypeName: returningCabinTypeName,
                        flightDetails: returningFlightDetails,
                    } = returningFlights || [];
                    data = {
                        ...data,
                        'Arrival City': `${destinationCityName} (${destination})`,
                        'Class': type === 'oneWay' ? departingCabinTypeName : `${departingCabinTypeName} - ${returningCabinTypeName}`,
                        'Departure City': `${originCityName} (${origin})`,
                        'Departure Date': new Date(departureDateTime),
                        'Is Charter': isCharter,
                        'Marketing Carrier': type === 'oneWay'
                            ? createCarriers(departingFlightDetails, 'marketingCarrierName')
                            : `${createCarriers(departingFlightDetails, 'marketingCarrierName')} / ${createCarriers(returningFlightDetails, 'marketingCarrierName')}`,
                        'Operating Carrier': type === 'oneWay'
                            ? createCarriers(departingFlightDetails, 'operatingCarrier')
                            : `${createCarriers(departingFlightDetails, 'operatingCarrier')} / ${createCarriers(returningFlightDetails, 'operatingCarrier')}`,
                        'Price': prices.reduce((result, item) => result + item.total, 0),
                        'Type': type === 'oneWay' ? 'One Way' : 'Round Trip',
                        'Passenger Count': adult + child + infant,
                        'Adult Count': adult,
                        'Child Count': child,
                        'Infant Count': infant,
                        'Passenger Matrix': [adult, child, infant],
                    };
                    if (returning && type === 'twoWay') {
                        data['Return Date'] = new Date(returnDepartureDateTime);
                    }
                } else {
                    data = {
                        ...data,
                        'Arrival Cities': destinationList.join(' - '),
                        'Class': flightGroups.map(item => item.cabinTypeName).join(' - '),
                        'Departure Cities': originList.join(' - '),
                        'Departure Date': new Date(departureDateTime),
                        // send the last date in the array 👇
                        'Return Date': new Date(returnDepartureDateTime),
                        'Is Charter': isCharter,
                        'Price': prices.reduce((result, item) => result + item.total, 0),
                        'Type': 'Multi-city',
                        'Passenger Count': adult + child + infant,
                        'Adult Count': adult,
                        'Child Count': child,
                        'Infant Count': infant,
                        'Passenger Matrix': [adult, child, infant],
                    };
                }
                if (stepNumber === 1) {
                    this.$webengage.logWebengageEvent('Checkout Started - International Flights', data);
                }
                if (stepNumber === 2) {
                    if (paymentMethod) {
                        data['Payment Method'] = paymentMethod;
                    }
                    this.$webengage.logWebengageEvent('Checkout Confirmed - International Flights', data);
                    this.$storage.setLocalStorage('intEECProducts', products);
                } else if (this.$storage.getLocalStorage('intEECProducts')) {
                    // if it's the first checkout step, delete any existing data
                    this.$storage.removeLocalStorage('intEECProducts');
                }
            } catch (error) {
                console.warn('[WEBENGAGE]', error); // eslint-disable-line no-console
            }
        },
    },
};
